import Service from '@/helpers/service'

export default {
    queue(params) {
        return Service().get('qc-inspection/queue', {params});
    },
    index(params) {
        return Service().get('qc-inspection/index', {params});
    },
    show(id) {
        return Service().get('qc-inspection/show/'+id);
    },
    create(params) {
        return Service().post('qc-inspection/create', params);
    },
    update(id, params) {
        return Service().post('qc-inspection/update/'+id, params);
    },
    delete(id) {
        return Service().post('qc-inspection/delete/'+id);
    },
}
